var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"h-full"},[(!_vm.audienceId)?_c('loader-box',{staticClass:"h-full",attrs:{"height":"100%"}}):_c('page-booking-audience',{attrs:{"audience-id":_vm.audienceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }